import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Copy, Check, ExternalLink } from 'lucide-react';
import { cn, formatHash, formatAddress, copyToClipboard } from '../../lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const HashDisplay = ({
  hash,
  type = 'hash', // 'hash', 'address', 'block', 'tx'
  link,
  truncate = true,
  showCopy = true,
  showExternal = false,
  className,
  startLen,
  endLen,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const success = await copyToClipboard(hash);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const formatFn = type === 'address' ? formatAddress : formatHash;
  const displayHash = truncate ? formatFn(hash, startLen, endLen) : hash;

  const content = (
    <span className={cn("copy-target inline-flex items-center gap-2 group", className)}>
      <span className="hash-link font-mono text-sm">{displayHash}</span>
      {showCopy && (
        <button
          onClick={handleCopy}
          className="copy-btn p-1 rounded hover:bg-white/10 transition-opacity"
          data-testid="copy-btn"
        >
          {copied ? (
            <Check className="w-3.5 h-3.5 text-green-400" />
          ) : (
            <Copy className="w-3.5 h-3.5 text-muted-foreground" />
          )}
        </button>
      )}
      {showExternal && (
        <ExternalLink className="w-3.5 h-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
      )}
    </span>
  );

  if (link) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link to={link} className="hover:underline">
              {content}
            </Link>
          </TooltipTrigger>
          <TooltipContent>
            <p className="font-mono text-xs max-w-xs break-all">{hash}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {content}
        </TooltipTrigger>
        <TooltipContent>
          <p className="font-mono text-xs max-w-xs break-all">{hash}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
